import httpClient from '@/http-client'

export const store = data => {
  return httpClient
    .post('/api/score-assessments/component-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/score-assessments/component-details/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProgramStructure = sc_setup_id => {
  return httpClient
    .get(`/api/score-assessments/get-program-structure/${sc_setup_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const storeCustomDivider = data => {
  return httpClient
    .post('/api/score-assessments/score-component-custom-dividers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const deleteCustomDivider = data => {
  return httpClient
    .post('/api/score-assessments/score-component-custom-dividers-delete', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const findCustomDivider = (sc_setup_id, program_structure_id) => {
  return httpClient
    .get(
      `/api/score-assessments/score-component-custom-dividers/${sc_setup_id}/${program_structure_id}`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getComponent = (
  sc_setup_id,
  program_structure_id,
  acp_id,
  class_id
) => {
  return httpClient
    .get(`/api/score-assessments/get-score-component-bases/${sc_setup_id}`, {
      params: {
        program_structure_id: program_structure_id,
        acp_id: acp_id,
        class_id: class_id
      }
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  find,
  store,
  getProgramStructure,
  storeCustomDivider,
  deleteCustomDivider,
  findCustomDivider,
  getComponent
}
